export default __webpack_public_path__ + "static/media/1 ALEPH.c5a09d9e.png";